module.exports = __webpack_public_path__ + "static/media/lamina25act2.4c6616fa.png";